export default {
  data () {
    return {
      total: -1,
      limit: 36,
      offset: 0,
      page: 0
    }
  },

  methods: {
    requestPrevPage (e) {
      this.prevPage()
    },
    requestNextPage (e) {
      this.nextPage()
    },
    requestNthPage (number) {
      this.$set(this, 'page', number)
    },
    resetPages () {
      this.requestNthPage(0)
    },

    setLimt (limit) {
      this.limit = limit
    },

    setOffset (offset) {
      this.offset = offset
    },

    nextPage () {
      if (this.getAvailableCount === -1) {
        this.page ++
        return
      }

      if ((this.page + 1) * this.getLimit > this.getAvailableCount) {
        return
      }

      this.page ++
    },
    prevPage () {
      this.page = Math.max(0, this.page - 1)
    }
  },

  computed: {
    getPaginatedList () {
      return this.getData || []
    },

    getLimit () {
      return this.limit
    },
    getOffset () {
      return this.page * this.getLimit
    },
    getCurrentPage () {
      return this.page
    },
    getAvailableCount () {
      return (this.getPaginationParams || {}).total || 0
    },

    getCurrentCountStart () {
      return this.getOffset
    },
    getCurrentCountEnd () {
      return this.getOffset + this.getPaginatedList.length
    },

    getPaginationInfo () {
      return {
        pageStart: this.getCurrentCountStart,
        pageEnd: this.getCurrentCountEnd,
        countTotal: this.getAvailableCount,
        canStepForth: this.canStepForth,
        canStepBack: this.canStepBack
      }
    },

    canStepForth () {
      if (this.getAvailableCount < 0 && this.getPaginatedList.length > 0) return true

      return ((this.page + 1) * this.getLimit < this.getAvailableCount)
    },
    canStepBack () {
      return this.page > 0
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/pagination/base.js